'use strict';

angular.module('licensure.services')
    .factory('FBForms', ['$http', '$q', 'Documents', function ($http, $q, Documents) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/fbforms', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/fbforms/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getAccess: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/fbforms/getAccess', {
                    params: {
                        formID: id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (args, attachments) {
                var d = $q.defer();
                var promises = [];

                if (args.form == null) {
                    d.resolve(null);
                }

                if (attachments != null) {
                    attachments.forEach(function (attachment) {
                        promises.push(Documents.upload(attachment).then(function (document) {
                            if (document != null) {
                                attachment.document_id = document.id;
                                attachment.document_code = document.code;
                                attachment.file = null;
                            }
                        }))
                    })
                }

                var method = 'POST';
                var url = apiLocation + '/api/fbforms/';
                if (!isUndefined(args.form.id) && !args.copy) {
                    method = 'PUT'
                    url += args.form.id
                }

                $q.all(promises).then(function () {
                    $http({
                        method: method,
                        url: url,
                        data: args
                    })
                        .then(function (response) {
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            // handle error
                        });
                }).catch(function (response) {
                    // handle error
                });             

                return d.promise;
            },

            saveAccess: function (formID, access) {
                var d = $q.defer();

                var url = apiLocation + '/api/fbforms/saveAccess';
                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        form_id: formID,
                        applicant_access: access.applicant_access
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/fbforms/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            createView: function (id) {
                var d = $q.defer();

                var data = {
                    formID: id
                };

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/fbforms/createview',
                    data: data
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            getReimbursementRules: function (form_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/fbforms/reimbursementrules/' + form_id, {

                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            updateFormResponseDocumentTypeHistorically: function (args) {
                var d = $q.defer();

                var url = apiLocation + '/api/fbforms/updateFormResponseDocumentTypeHistorically';
                $http({
                    method: 'Put',
                    url: url,
                    data: {
                        FormId: args.formId,
                        DocumentTypeId: args.documentTypeId
                    }
                })
                    .then(function () {
                        d.resolve(true);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        }
    }])
;